export type LogCategory = 'app' | 'env' | 'user' | 'theme' | 'api' | 'error'

const CATEGORY_STYLES: Record<LogCategory, string> = {
  app: 'color: #2563eb; font-weight: 700;',
  env: 'color: #15803d; font-weight: 700;',
  user: 'color: #a16207; font-weight: 700;',
  theme: 'color: #7c3aed; font-weight: 700;',
  api: 'color: #0369a1; font-weight: 700;',
  error: 'color: #b91c1c; font-weight: 700;'
}

const MESSAGE_STYLE = 'color: inherit; font-weight: 400;'
const WELCOME_STYLE = 'color: #2563eb; font-family: monospace; font-weight: 700; line-height: 1.2;'
const WELCOME_ART = String.raw`
__        __ _____ _      ____ ___  __  __ _____
\ \      / /| ____| |    / ___/ _ \|  \/  | ____|
 \ \ /\ / / |  _| | |   | |  | | | | |\/| |  _|
  \ V  V /  | |___| |___| |__| |_| | |  | | |___
   \_/\_/   |_____|_____|\____\___/|_|  |_|_____|

GMI Character Playground · development console
WELCOME TO THE PLAYGROUND
`

let hasLoggedWelcome = false

function isDevelopmentLogEnabled() {
  return import.meta.env.DEV
}

/**
 * Emits errors in every environment; other diagnostics stay in local Vite development.
 * Never use this helper for credentials, tokens, or other secrets.
 */
export function log(message: string, category: LogCategory = 'app', details?: unknown) {
  if (category !== 'error' && !isDevelopmentLogEnabled()) return

  const argumentsForConsole: unknown[] = [
    `%c[${category.toUpperCase()}]%c ${message}`,
    CATEGORY_STYLES[category],
    MESSAGE_STYLE
  ]
  if (details !== undefined) argumentsForConsole.push(details)

  if (category === 'error') {
    console.error(...argumentsForConsole)
    return
  }

  // eslint-disable-next-line no-console
  console.log(...argumentsForConsole)
}

/** Emits the development-console banner once, before the application mounts. */
export function logWelcome() {
  if (!isDevelopmentLogEnabled() || hasLoggedWelcome) return

  hasLoggedWelcome = true
  // eslint-disable-next-line no-console
  console.log(`%c${WELCOME_ART}`, WELCOME_STYLE)
}
